import * as firebase from 'firebase/app'
import { GuardiansCollection, AllianceEventsCollection } from './Constants'

export async function getGuardian(id) {
    return fetch(GuardiansCollection, id)
}

async function fetch(collection, id) {
    return firebase.firestore().collection(collection).doc(id).get().then(snapshot => {
        return snapshot.data()
    })
}

export async function getUpcomingAllianceEvents() {
    return getAllianceEvents("upcoming")
}

export async function getCurrentAllianceEvents() {
    return getAllianceEvents("current")
}

async function getAllianceEvents(field) {
    return firebase.firestore().collection(AllianceEventsCollection).where(field, "==", true).get().then(snapshot => {
        return snapshot.docs?.map(doc => { return doc.data()}).sort((a, b) => (a.duration < b.duration) ? 1 : -1)
    })
}